// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"_0qKwHMHf","wrapper":"_MNVuyBWg"};